import { render, staticRenderFns } from "./MethodChoose.vue?vue&type=template&id=3eb446a1&scoped=true&"
import script from "./MethodChoose.vue?vue&type=script&lang=js&"
export * from "./MethodChoose.vue?vue&type=script&lang=js&"
import style0 from "./MethodChoose.vue?vue&type=style&index=0&id=3eb446a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb446a1",
  null
  
)

export default component.exports